module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "electorate-details"
  }, [_c('form', {
    staticClass: "search",
    attrs: {
      "id": "search"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.selectAddress($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "address",
      "placeholder": "Use your postcode to locate threatened wildlife near you",
      "id": "address"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "focus": _vm.logSearchBoxFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.selectAddress
    }
  }, [_c('i', {
    staticClass: "fal fa-search"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('h4', {
    staticClass: "electorate-name"
  }, [_vm._v("In " + _vm._s(_vm.electorateName === "" ? "Australian neighbourhood" : "your local area"))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "section species"
  }, [_c('div', {
    staticClass: "count"
  }, [_c('p', [_vm._v(_vm._s(_vm.speciesCount))])]), _vm._v(" "), _vm._m(0, false, false)]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "section middle"
  }, [_c('div', {
    staticClass: "section-content"
  }, [_c('div', {
    staticClass: "icon grade",
    style: (_vm.bgColor)
  }, [_c('p', {
    staticClass: "grade"
  }, [_vm._v(_vm._s(_vm.electorateGrade))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [(_vm.electorateName === '') ? _c('p', {
    staticClass: "uppercase"
  }, [_vm._v("\n                Threatened species grade in your local area\n              ")]) : _vm._e(), _vm._v(" "), (_vm.electorateName !== '') ? _c('p', {
    staticClass: "uppercase"
  }, [_vm._v("\n                Species recovery grade in your local area\n              ")]) : _vm._e()])])]), _vm._v(" "), _vm._m(2, false, false)]), _vm._v(" "), _c('div', {
    staticClass: "section btn"
  }, [_c('button', {
    staticClass: "uppercase",
    attrs: {
      "type": "button",
      "name": "dismiss"
    },
    on: {
      "click": _vm.makeDifference
    }
  }, [(_vm.electorateName !== '') ? _c('span', [_vm._v("add your voice")]) : _c('span', [_vm._v("Send a message")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "uppercase"
  }, [_vm._v("\n              Animals and plants threatened with extinction\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "separator"
  }, [_c('div', {
    staticClass: "bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "separator end"
  }, [_c('div', {
    staticClass: "bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-150dc88e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=trkhxoihlnq!./~/string-replace-webpack-plugin/loader.js?id=gism0w5tdia!./src/components/threatened-species/ElectorateDetails.vue
// module id = 757
// module chunks = 0